import React, { useState } from 'react';
import { galleryData } from '../data/mock';
import { X, ZoomIn } from 'lucide-react';

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages =
    activeCategory === 'All'
      ? galleryData.images
      : galleryData.images.filter((img) => img.category === activeCategory);

  return (
    <section id="gallery" className="py-20 md:py-28 bg-[#FAF9F7]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="font-sans text-sm text-[#C9A962] tracking-[0.2em] uppercase mb-4 block">
            Our Portfolio
          </span>
          <h2 className="section-title text-3xl md:text-4xl">Photo Gallery</h2>
          <div className="decorative-line" />
          <p className="section-subtitle max-w-2xl mx-auto">
            Glimpses of beautiful celebrations hosted at Elite Marriage Lawns
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {galleryData.categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-2.5 rounded-full font-sans text-sm tracking-wider uppercase transition-all duration-300 ${
                activeCategory === category
                  ? 'bg-[#C9A962] text-white shadow-lg'
                  : 'bg-white text-[#6B6259] hover:bg-[#C9A962]/10 border border-[#D4C4B0]'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className={`relative group cursor-pointer overflow-hidden rounded-lg ${
                index === 0 || index === 5 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className={`w-full object-cover transition-transform duration-500 group-hover:scale-110 ${
                  index === 0 || index === 5 ? 'h-full min-h-[300px] md:min-h-[400px]' : 'h-48 md:h-56'
                }`}
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-between p-4">
                <span className="text-white font-sans text-sm tracking-wider uppercase">
                  {image.category}
                </span>
                <ZoomIn size={24} className="text-white" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 animate-fade-in"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-[#C9A962] transition-colors"
            onClick={() => setSelectedImage(null)}
            aria-label="Close"
          >
            <X size={36} />
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
          <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/80 font-sans tracking-wider uppercase text-sm">
            {selectedImage.category}
          </p>
        </div>
      )}
    </section>
  );
};

export default Gallery;
